import Navigation from '@/components/navigation/Navigation'
import UserWatches from '@/components/user/UserWatches'
import UserWatchesPatients from '@/components/user/watches/UserWatchesPatients'
import UserWatchesDevices from '@/components/user/watches/UserWatchesDevices'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/:user_uid',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'watches',
				name: 'WatchList',
				meta: {
					requiredAuth: true
				},
				redirect: {
					name: 'UserWatchesPatients'
				},
				components: {
					default: UserWatches,
					menu: Navigation
				},
				props: {
					default: true,
					menu: true
				},
				children: [
					{
						path: 'patients',
						name: 'UserWatchesPatients',
						component: UserWatchesPatients,
						props: true
					},
					{
						path: 'devices',
						name: 'UserWatchesDevices',
						component: UserWatchesDevices,
						props: true
					}
				]
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/watches.js